/**
 * @generated SignedSource<<2a8106b387e0d3d0c192b3c68caeac21>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type AssistantMode = "aiStory" | "assistant" | "cardDetail" | "letsPractise" | "listenVocab" | "speaking" | "%future added value";
export type grammarExplanationQuery$variables = {
  context?: string | null;
  correctedText: string;
  language?: string | null;
  mode?: AssistantMode | null;
  responseLanguage?: string | null;
  text: string;
};
export type grammarExplanationQuery$data = {
  readonly grammarExplanation: string;
};
export type grammarExplanationQuery = {
  response: grammarExplanationQuery$data;
  variables: grammarExplanationQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "context"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "correctedText"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "language"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "mode"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "responseLanguage"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "text"
},
v6 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "context",
        "variableName": "context"
      },
      {
        "kind": "Variable",
        "name": "correctedText",
        "variableName": "correctedText"
      },
      {
        "kind": "Variable",
        "name": "language",
        "variableName": "language"
      },
      {
        "kind": "Variable",
        "name": "mode",
        "variableName": "mode"
      },
      {
        "kind": "Variable",
        "name": "responseLanguage",
        "variableName": "responseLanguage"
      },
      {
        "kind": "Variable",
        "name": "text",
        "variableName": "text"
      }
    ],
    "kind": "ScalarField",
    "name": "grammarExplanation",
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "grammarExplanationQuery",
    "selections": (v6/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v5/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v4/*: any*/),
      (v3/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "grammarExplanationQuery",
    "selections": (v6/*: any*/)
  },
  "params": {
    "cacheID": "94e66a252bbfe07ca51d7bbe90f7e688",
    "id": null,
    "metadata": {},
    "name": "grammarExplanationQuery",
    "operationKind": "query",
    "text": "query grammarExplanationQuery(\n  $text: String!\n  $correctedText: String!\n  $language: String\n  $responseLanguage: String\n  $mode: AssistantMode\n  $context: String\n) {\n  grammarExplanation(text: $text, correctedText: $correctedText, language: $language, responseLanguage: $responseLanguage, context: $context, mode: $mode)\n}\n"
  }
};
})();

(node as any).hash = "adc9043359e723579b16a84978e9adb0";

export default node;
